// SVG geometry retained under the MIT license in LICENSE.txt.
import React from 'react';
import { SvgIcon } from '../primitives';
const ArrowDropDown = React.forwardRef(function ArrowDropDown(props, ref) {
    return <SvgIcon {...props} ref={ref}><path d="m7 10 5 5 5-5z"/></SvgIcon>;
});
export default ArrowDropDown;
